import { PortalModule } from "@/@core";

export const module = {
  name: "dcm",
  routes: [],
} as PortalModule;
